import FootballStatsCategory from "../../../stats/football-stats-category";
import FootballState from "../../../state/football-state";
import StatsRule from "../../../../common/stats-rule";

export default class PunterStats extends StatsRule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return (
            [FootballState.Punt, FootballState.CflKick].some(
                (state) => state === fragment.associatedState
            ) &&
            super.applicable(gameContext, ruleContext, eventConfiguration, {
                play,
                fragment
            })
        );
    }

    _isTouchback(play, fragment) {
        return play
            .getFragmentsBetween(fragment, FootballState.CflKick)
            .some(
                ({ associatedState }) =>
                    associatedState === FootballState.TouchBack
            );
    }

    _in20(puntFragment, gameContext) {
        let isIn20;
        const { gameConfig, homeTeamHasPossession } = gameContext;
        const { general } = gameConfig;
        const { puntedTo } = puntFragment;
        if (homeTeamHasPossession) {
            isIn20 =
                puntedTo < general.fieldLength &&
                puntedTo >= general.fieldLength - 20;
        } else {
            isIn20 = puntedTo > 0 && puntedTo <= 20;
        }

        return isIn20;
    }

    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        let yardsPunted =
            (fragment.puntedTo - gameContext.fieldPosition) *
            gameContext.getFieldDirectionMultiplier();

        const rougeFragment = play
            .getFragmentsBetween(fragment, [FootballState.CflKick])
            .find(
                ({ associatedState }) => associatedState === FootballState.Rouge
            );

        if (this._isTouchback(play, fragment)) {
            /***
             * The rule says that in a touchback, the total punted yards are equal to the actual punted yards minus
             * the touchback yardline.
             */
            yardsPunted -= gameContext.gameConfig.spots.touchbackYardline;
        }

        const stats = [];
        if (this._in20(fragment, gameContext)) {
            this.addStats(
                {
                    gameId: play.gameId,
                    playId: play.id,
                    period: gameContext.currentPeriod,
                    teamId: fragment.puntedBy.teamId,
                    playerId: fragment.puntedBy.id,
                    driveId: gameContext.currentDriveId,
                    fragmentId: fragment.id,
                    category: FootballStatsCategory.PUNT_IN20,
                    values: {
                        completed: 1
                    }
                },
                stats
            );
        }

        this.addStats(
            {
                gameId: play.gameId,
                playId: play.id,
                period: gameContext.currentPeriod,
                teamId: fragment.puntedBy.teamId,
                playerId: fragment.puntedBy.id,
                driveId: gameContext.currentDriveId,
                fragmentId: fragment.id,
                category: FootballStatsCategory.PUNT,
                values: {
                    completed: 1,
                    attempted: 1,
                    yards: yardsPunted,
                    rouge: rougeFragment ? 1 : 0
                }
            },
            stats
        );

        return stats;
    }
}
